import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import Cookies from 'js-cookie';
import GenericVideoDisplayListing from '../listings/GenericVideoDisplayListing/GenericVideoDisplayListingJsFile';
import fetch from 'cross-fetch';
import { Configuration } from '../config';

let store;

let contensisUserName = Cookies.get("ContensisCMSUserName");

const headers = {ContensisCMSUserName: encodeURIComponent(contensisUserName)};

function GenericVideoDisplayApp() {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<GenericVideoDisplayListing store={store} />
			</RouterProvider>
		</Provider>
	);
}



export function renderGenericVideoDisplay(id) {
	if (!store) {
		store = configureStore(router);
	}

	var groups;
	var isAuth;


	fetch( Configuration.rootUrl+"/REST/Contensis/Security/GetUserInfo", {headers})
	.then(res => {
		if (res.status >= 400) {
			isAuth = false;
		throw new Error("Bad response from server");
		}
		return res.json();
	})
	.then(user => {
		var j = JSON.parse(user);
		groups = j.GroupCollection.map(function(item) { return item['GroupName'];});
		isAuth = (groups.includes("@Industrial Member") || groups.includes("@TWI Staff"));		


		store.dispatch(Actions.initialiseSettings('GenericVideoDisplayAppId', groups, isAuth));
	})
	.catch(err => {
		isAuth = false;
		console.error(err);
	});

	router.start(() => {
		ReactDOM.render(<GenericVideoDisplayApp />, document.getElementById(id));
	});
}

